module.exports = __webpack_public_path__ + "static/img/npo-zappelin.a71b0d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/npo-zappelin.png
// module id = 670
// module chunks = 64